import { ChartArea, ChartColumn, ChartLine } from 'lucide-react';
import { cn } from '../../lib/utils';
import { CHART_STYLES, type ChartStyle } from './chartPrefs';

const ICON: Record<ChartStyle, typeof ChartColumn> = {
  bar: ChartColumn,
  line: ChartLine,
  area: ChartArea,
};
const TITLE: Record<ChartStyle, string> = { bar: 'Bar', line: 'Line', area: 'Area' };

// Compact bar / line / area segmented control (per-metric chart style). Stops
// click propagation so it can live inside a clickable hero card without
// triggering selection.
export function ChartStyleToggle({
  value,
  onChange,
  className,
}: {
  value: ChartStyle;
  onChange: (style: ChartStyle) => void;
  className?: string;
}) {
  return (
    <div
      className={cn('inline-flex overflow-hidden rounded border border-slate-200 bg-white', className)}
      role="group"
      aria-label="Chart style"
    >
      {CHART_STYLES.map((s) => {
        const Icon = ICON[s];
        const active = s === value;
        return (
          <button
            key={s}
            type="button"
            title={`${TITLE[s]} chart`}
            aria-pressed={active}
            onClick={(e) => {
              e.stopPropagation();
              onChange(s);
            }}
            className={cn(
              'flex items-center justify-center px-1.5 py-1 transition-colors',
              active ? 'bg-kyck-50 text-kyck-700' : 'text-slate-400 hover:bg-slate-50 hover:text-slate-600',
            )}
          >
            <Icon className="h-3.5 w-3.5" aria-hidden />
          </button>
        );
      })}
    </div>
  );
}
